import { render, staticRenderFns } from "./ClientTestimonials.vue?vue&type=template&id=018ab4f4&scoped=true"
import script from "./ClientTestimonials.vue?vue&type=script&lang=js"
export * from "./ClientTestimonials.vue?vue&type=script&lang=js"
import style0 from "./ClientTestimonials.vue?vue&type=style&index=0&id=018ab4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018ab4f4",
  null
  
)

export default component.exports